<template>
  <div class="p-6 bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
    <div v-if="loading && id" class="flex justify-center items-center h-64">
      <svg class="animate-spin h-12 w-12 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    </div>

    <div v-else class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 p-6">

      <form @submit.prevent="" enctype="multipart/form-data">
        <div class="mb-8">
          <div class="grid grid-cols-7 gap-6">
            <div class="col-span-1">
              <div class="mt-2" v-if="form.image">
                <img :src="image_source(form.image)" class="h-32 w-32 object-cover rounded-md border">
              </div>
            </div>
            <div class="col-span-3">
              <label for="name" class="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                نام محصول
              </label>
              <input
                  v-model="form.name"
                  type="text"
                  id="name"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                  :class="{'border-red-300': errors.name}"
              >
              <p v-if="errors.name" class="mt-1 text-sm text-red-600">{{ errors.name }}</p>
            </div>

            <div class="col-span-3">
              <label for="sku" class="block text-sm font-medium text-gray-700 mb-1 flex items-center">
                <span class="text-red-500 ml-1">*</span>
                کد SKU
              </label>
              <div class="relative">
                <input
                    v-model="form.sixteen_digit_code"
                    type="text"
                    id="sku"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                    :class="{'border-red-300': errors.sixteen_digit_code}"
                >
              </div>
              <p v-if="errors.sixteen_digit_code" class="mt-1 text-sm text-red-600">{{ errors.sixteen_digit_code }}</p>
            </div>
          </div>
        </div>
        <div>
          <div class="grid grid-cols-1 gap-3">
            <div>
              <label for="brand" class="block text-sm font-medium text-gray-700 mb-1">برند</label>
              <brand-select scope="local" id="brand" v-model="form.brand"></brand-select>
              <p v-if="errors.brand" class="mt-1 text-sm text-red-600">{{ errors.brand }}</p>
            </div>
            <category-tree-select
                label="دسته بندی"
                v-model="form.categorization"
                :categories="categorizations"
                :errors="errors"
            />
            <category-tree-select
                label="خواص"

                v-model="form.avails"
                :categories="avails"
                :errors="errors"
            />
            <category-tree-select
                label="ویژگی"
                v-model="form.feature"
                :categories="features"
                :errors="errors"
            />
          </div>
        </div>

        <div class="flex justify-end gap-4 pb-10 mt-3">
          <button
              v-if="!popUp"
              type="button"
              @click="goBack"
              class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-200"
          >
            انصراف
          </button>
          <button
              @click="submitForm"
              class="px-4 py-2 border border-transparent rounded-md font-white text-sm font-medium bg-gradient-to-r from-blue-500 to-blue-600 items-center"
              :disabled="submitting"
          >
            <svg v-if="submitting" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span class="white--text">
              {{ id ? 'ذخیره تغییرات' : 'ایجاد محصول' }}
            </span>
          </button>
        </div>
      </form>
    </div>
    <transition name="slide-fade">
      <div v-if="showNotification"
           class="fixed bottom-4 right-4 z-50 flex items-center p-4 w-full max-w-xs text-gray-500 bg-white rounded-lg shadow-lg border border-gray-200
                  !bg-green-50 !border-green-200 !text-green-700" >

        <div class="inline-flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-lg text-green-500 bg-green-100" >
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
          </svg>
        </div>
        <div class="mr-3 text-sm font-normal pr-2">کالا با موفقیت ثبت شد</div>
        <button @click="showNotification = false" class="mr-auto text-gray-400 hover:text-gray-900 rounded-lg p-1.5 hover:bg-gray-100">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
        </button>
      </div>
    </transition>

  </div>
</template>

<script>
import CategorySelect from "@/components/selects/CategorySelect";
import CategoryTreeSelect from "@/modules/product_admin/CategoryTreeSelect";
import AdminVariationFrom from "@/modules/product_admin/AdminVariationForm";
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import DateField from "@/components/mcomponents/cleave/DateField";
import StoreSelect from "@/components/selects/StoreSelect";
import BrandSelect from "@/components/selects/BrandSelect";

export default {
  name: 'AdminProductNewCat',
  components: {BrandSelect, StoreSelect, AdminVariationFrom, CategoryTreeSelect, CategorySelect, quillEditor, DateField},
  watch: {
    id() {
      if (this.id) {
        this.fetchProduct()
      }
      if (!this.id) {
        this.form = {
          name: '',
          sixteen_digit_code: '',
          explanation: '',
          aisle: '',
          faq: '',
          blog: '',
          schema: '',
          faq_schema: '',
          shelf_number: '',
          inventories_in_stores: [],
          packing_inventory: {
            store: 1,
            name: 'پردازش',
            inventory: 0,
            minimum_inventory: 0
          },
          summary_explanation: '',
          how_to_use: '',
          regular_price: 0,
          price: 0,
          currency: '',
          inventory: 0,
          postal_weight: 0,
          length: 0,
          product_date: null,
          expired_date: null,
          width: 0,
          height: 0,
          status: 'draft',
          avails: [],
          categorization: [],
          feature: [],
          brand: '',
          product_type: 'simple',
          image: null,
          images: [],
          legend_pricing: 'false',
          base_price: 0,
          profit_type: 'percent',
          profit_margin: 0,
          discount_type: 'percent',
          discount_margin: 0,
          variations: []
        }
      }
    }
  },
  props: {
    id: {},
    popUp: {
      default: false
    },
  },
  data() {
    return {
      packing_inventory: {
        store: 1,
        name: 'پردازش',
        inventory: 0,
        minimum_inventory: 0
      },
      loading: false,
      submitting: false,
      errors: {},
      stores: [],
      editorOptions: {
        placeholder: 'متن خود را وارد کنید...',
        theme: 'snow',
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, 5,6,  false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean']
          ]
        }
      },

      form: {
        name: '',
        sixteen_digit_code: '',
        explanation: '',
        faq: '',
        blog: '',
        schema: '',
        faq_schema: '',
        summary_explanation: '',
        how_to_use: '',
        regular_price: 0,
        price: 0,
        currency: '',
        inventory: 0,
        postal_weight: 0,
        length: 0,
        product_date: null,
        expired_date: null,
        width: 0,
        height: 0,
        status: 'draft',
        content_status: 'waiting',
        categorization: [],
        feature: [],
        avails: [],
        brand: '',
        product_type: 'simple',
        image: null,
        images: [],
        legend_pricing: 'false',
        base_price: 0,
        profit_type: 'percent',
        profit_margin: 0,
        discount_type: 'percent',
        discount_margin: 0,
        variations: [],
        aisle: '',
        shelf_number: '',
        inventories_in_stores: [],
        packing_inventory: {
          store: 1,
          name: 'پردازش',
          inventory: 0,
          minimum_inventory: 0
        },
      },
      currencies: [],
      avails: [],
      features: [],
      categorizations: [],
      deletedGalleryImages: [],
      showNotification: false,
      brands: [],
      showVariationForm: false,
      editingVariation: null,
      editingIndex: -1
    }
  },
  mounted() {
    this.fetchCategories();
    this.fetchAvails();
    this.fetchFeatures();
    this.fetchBrands();

    if (this.id) {
      this.fetchProduct();
    } else {
      this.generateSKU();
    }
  },
  computed: {
    store_with_inventory_ids() {
      return this.form.inventories_in_stores.map(item => item.store);
    },
    has_new_store() {
      return this.stores.every(item => this.store_with_inventory_ids.includes(item))
    },

    current_currency() {
      if (this.form.currency) {
        return this.currencies.find(c => c.id === this.form.currency)
      }
      return {id: 0, name: 'تومان', exchange_rate_to_toman: 1}
    },
    base_price_with_rate() {
      return this.current_currency.exchange_rate_to_toman * this.form.base_price
    },
    final_amount() {
      let profitAmount = 0;
      if (this.form.profit_type == 'percent') {
        profitAmount = this.base_price_with_rate / 100 * this.form.profit_margin;
      } else {
        profitAmount = this.form.profit_margin;
      }

      let priceWithProfit = profitAmount + this.base_price_with_rate;

      let discountAmount = 0;
      if (this.form.discount_type === 'percent') {
        discountAmount = priceWithProfit / 100 * this.form.discount_margin;
      } else {
        discountAmount = this.form.discount_margin;
      }

      return priceWithProfit - discountAmount;
    },
    discount_sum() {
      let profitAmount = 0;
      if (this.form.profit_type == 'percent') {
        profitAmount = this.base_price_with_rate / 100 * this.form.profit_margin;
      } else {
        profitAmount = this.form.profit_margin;
      }

      let priceWithProfit = profitAmount + this.base_price_with_rate;

      let discountAmount = 0;
      if (this.form.discount_type === 'percent') {
        discountAmount = priceWithProfit / 100 * this.form.discount_margin;
      } else {
        discountAmount = this.form.discount_margin;
      }

      return discountAmount;
    },
    profit_sum() {
      let profitAmount = 0;
      if (this.form.profit_type == 'percent') {
        profitAmount = this.base_price_with_rate / 100 * this.form.profit_margin;
      } else {
        profitAmount = this.form.profit_margin;
      }

      return profitAmount;
    },
  },
  methods: {
    asString(v) {
      if (v == null) return ''
      if (typeof v === 'string') return v
      return ''
    },
    getStores() {
      this.request({
        url: this.endpoint(`main/store`),
        method: "get",
        success: data => {
          this.stores = []
          for (let store of data) {
            if (store.id != 1) {
              this.stores.push(store.id)
            }
          }
        }
      })
    },

    removeStore(index) {
      this.form.inventories_in_stores.splice(index, 1);
    },
    removeMainImage() {
      this.form.image = null;
    },
    reset() {
      this.id = null
      this.$router.push('/panel/adminProductForm')
    },
    removeGalleryImage(index) {
      if (this.form.images[index].id) {
        this.deletedGalleryImages.push(this.form.images[index].id);
      }
      this.form.images.splice(index, 1);
    },

    fetchProduct() {
      this.request({
        url: this.endpoint(`product/adminProductGet/${this.id}`),
        method: 'get',
        success: (response) => {
          this.form = {
            name: response.name || '',
            sixteen_digit_code: response.sixteen_digit_code || '',
            explanation: this.asString(response.explanation),
            summary_explanation: this.asString(response.summary_explanation),
            how_to_use: this.asString(response.how_to_use),
            faq: this.asString(response.faq),
            blog: this.asString(response.blog),
            schema: this.asString(response.schema),
            faq_schema: this.asString(response.faq_schema),
            expired_date: response.expired_date || null,
            product_date: response.product_date || null,
            regular_price: response.regular_price || 0,
            price: response.price || 0,
            currency: response.currency || '',
            inventory: response.calculate_current_inventory || 0,
            postal_weight: response.postal_weight || 0,
            length: response.length || 0,
            width: response.width || 0,
            height: response.height || 0,
            status: response.status || 'draft',
            content_status: response.content_status || 'waiting',
            categorization: response.categorization || '',
            avails: response.avails || '',
            feature: response.feature || '',
            aisle: response.aisle || '',
            shelf_number: response.shelf_number || '',
            inventories_in_stores: response.inventories_in_stores || [],
            packing_inventory: response.packing_inventory,
            brand: response.brand || '',
            product_type: response.product_type || 'simple',
            image: response.picture || null,
            images: [],
            variations: response.variations || [],
            legend_pricing: 'false',
            base_price: response.base_price,
            profit_type: response.profit_type,
            profit_margin: response.profit_margin,
            discount_type: response.discount_type,
            discount_margin: response.discount_margin,

          };

          for (let item of response.gallery) {
            this.form.images.push({
              id: item.id,
              file: null,
              preview: item.picture
            })
          }
        },
      })
    },
    fetchCategories() {
      this.request({
        url: this.endpoint('product/categorizationTree'),
        method: 'get',
        success: (data) => {
          this.categorizations = data
        }
      })
    },
    fetchAvails() {
      this.request({
        url: this.endpoint('product/availsTree'),
        method: 'get',
        success: (data) => {
          this.avails = data
        }
      })
    },
    fetchFeatures() {
      this.request({
        url: this.endpoint('product/featureTree'),
        method: 'get',
        success: (data) => {
          this.features = data
        }
      })
    },

    fetchBrands() {
      this.request({
        url: this.endpoint('api/brands'),
        method: 'get',
        success: (data) => {
          this.brands = data
        }
      })
    },
    fetchCurrency() {
      this.request({
        url: this.endpoint('main/currency'),
        method: 'get',
        success: (data) => {
          this.currencies = data
        }
      })
    },
    generateSKU() {
      this.form.sixteen_digit_code = ''
    },
    addStoreInventory() {
      this.form.inventories_in_stores.push(
          {
            name: 'new',
            inventory: 0,
            store: null
          }
      )
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {

        const reader = new FileReader();
        reader.onload = (e) => {
          this.form.image = {
            file: file,
            preview: e.target.result
          };
        };
        reader.readAsDataURL(file);
      }
    },
    showNotificationMessage() {
      this.showNotification = true;
      setTimeout(() => {
        this.showNotification = false;
      }, 5000);
    },

    handleGalleryUpload(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        Array.from(files).forEach(file => {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.form.images.push({
              id: null,
              file: file,
              preview: e.target.result
            });
          };
          reader.readAsDataURL(file);
        });
      }
    },

    submitForm() {
      this.submitting = true;
      this.errors = {};
      try {
        const formData = new FormData();
        const categorization_ids = this.form.categorization.map(cat => cat.id);
        const features_ids = this.form.feature.map(cat => cat.id);
        const avails_ids = this.form.avails.map(cat => cat.id);
        formData.append('name', this.form.name);
        formData.append('sixteen_digit_code', this.form.sixteen_digit_code);
        formData.append('explanation', this.form.explanation || '');
        formData.append('faq', this.form.faq || '');
        formData.append('blog', this.form.blog || '');
        formData.append('schema', this.form.schema || null);
        formData.append('faq_schema', this.form.faq_schema || null);
        formData.append('summary_explanation', this.form.summary_explanation || '');
        formData.append('how_to_use', this.form.how_to_use || '');
        formData.append('regular_price', this.form.regular_price);
        formData.append('price', this.form.price);
        formData.append('currency', this.form.currency);
        formData.append('product_date', `${this.form.product_date || ''}`);
        formData.append('expired_date', `${this.form.expired_date || ''}`);
        formData.append('calculate_current_inventory', this.form.calculate_current_inventory || 0);
        formData.append('postal_weight', this.form.postal_weight || 0);
        formData.append('length', this.form.length || 0);
        formData.append('width', this.form.width || 0);
        formData.append('height', this.form.height || 0);
        formData.append('status', this.form.status);
        formData.append('content_status', this.form.content_status);
        formData.append('product_type', this.form.product_type);
        formData.append('aisle', this.form.aisle);
        formData.append('shelf_number', this.form.shelf_number);
        formData.append('inventories_in_stores', JSON.stringify(this.form.inventories_in_stores));
        formData.append('packing_inventory', JSON.stringify(this.form.packing_inventory));
        formData.append('legend_pricing', this.form.legend_pricing);
        formData.append('base_price', this.form.base_price || 0);
        formData.append('profit_type', this.form.profit_type || 'percent');
        formData.append('profit_margin', this.form.profit_margin || 0);
        formData.append('discount_type', this.form.discount_type || 'percent');
        formData.append('discount_margin', this.form.discount_margin || 0);
        formData.append('new_inventory', this.form.inventory || 0);
        if (this.form.variations && this.form.variations.length > 0) {
          let formattedVariationsData = []
          let counter = 1
          for (let variation of this.form.variations) {
            let variationData = {
              id: variation.id || null,
              variation_title: variation.variation_title,
              name: variation.name,
              price: variation.price,
              regular_price: variation.regular_price,
              status: variation.status,
              content_status: variation.content_status,
              sixteen_digit_code: variation.sixteen_digit_code,
              length: variation.length,
              height: variation.height,
              width: variation.width,
              aisle: variation.aisle,
              shelf_number: variation.shelf_number,
              packing_inventory: JSON.stringify(variation.packing_inventory),
              inventories_in_stores: JSON.stringify(variation.inventories_in_stores),
              explanation: variation.explanation,
              summary_explanation: variation.summary_explanation,
              product_date: `${variation.product_date || ''}`,
              expired_date: `${variation.expired_date || ''}`,
              how_to_use: variation.how_to_use,
              legend_pricing: variation.legend_pricing,
              base_price: variation.base_price,
              profit_type: variation.profit_type,
              profit_margin: variation.profit_margin,
              discount_type: variation.discount_type,
              discount_margin: variation.discount_margin,
              postal_weight: variation.postal_weight,
              new_inventory: variation.calculate_current_inventory,
            }

            if (!variation.image && this.id) {
              variationData['file_key'] = 'remove';
            } else if (variation.image) {
              if (typeof variation.image === 'string') {
                variationData['file_key'] = 'same';
              } else {
                variationData['file_key'] = `var_image_${counter}`;
                formData.append(`var_image_${counter}`, variation.image.file);

              }
            }
            formattedVariationsData.push(variationData)
            counter += 1
          }
          formData.append('variations', JSON.stringify(formattedVariationsData));
        }

        categorization_ids.forEach(pk => {
          formData.append('categorization_ids', pk);
        });
        avails_ids.forEach(pk => {
          formData.append('avails_ids', pk);
        });
        features_ids.forEach(pk => {
          formData.append('features_ids', pk);
        });


        if (this.form.brand) {
          formData.append('brand', this.form.brand);
        }

        if (!this.form.image && this.id) {
          formData.append('remove_image', 'true');
        } else if (this.form.image) {
          if (this.form.image.file) {
            formData.append('image', this.form.image.file);
            formData.append('remove_image', 'false');
          } else if (typeof this.form.image === 'string') {
            formData.append('remove_image', 'false');
          }
        }

        if (this.form.images && this.form.images.length > 0) {
          this.form.images.forEach(img => {
            if (img.file) {
              formData.append('images', img.file);
            }
          });
        }

        if (this.deletedGalleryImages.length > 0) {
          this.deletedGalleryImages.forEach(pk => {
            formData.append('deleted_gallery_images', pk);
          });
        }

        const url = this.id
            ? this.endpoint(`product/adminProductUpdate/${this.id}`)
            : this.endpoint('product/adminProductCreate');

        const method = this.id ? 'put' : 'post';


        this.request({
          url,
          method,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          success: (data) => {
            this.showNotificationMessage()
            this.id = data.id
            this.$emit('saved', {})
            this.fetchProduct()
          }

        });
      } catch (error) {
        if (error.response && error.response.data) {
          this.errors = error.response.data.errors || {};
          this.$toast.error('لطفا مقادیر را بررسی کنید');
        } else {
          this.$toast.error('خطا در ذخیره اطلاعات');
          console.error('Error submitting form:', error);
        }
      } finally {
        this.submitting = false;
      }
    },
    image_source(image) {
      if (!image) return 'https://via.placeholder.com/150';
      if (/^\/media/.test(image)) return this.img_source(image)
      if (typeof image === 'string') {
        return image;
      }
      if (image.preview) {
        return image.preview;
      }
      if (image.file) {
        return URL.createObjectURL(image.file);
      }
      return 'https://via.placeholder.com/150';
    },
    goBack() {
      this.$router.push({ name: 'AdminProductList', query: { ...this.$route.query } })
    },
    handleSaveVariation(variationData) {
      if (this.editingIndex >= 0) {
        this.form.variations.splice(this.editingIndex, 1, variationData)
      } else {
        this.form.variations.push(variationData)
      }

      this.cancelVariationEdit()
    },

    editVariation(variation) {
      this.editingVariation = variation
      this.editingIndex = this.form.variations.indexOf(variation)
      this.showVariationForm = true
    },

    removeVariation(index) {
      this.form.variations.splice(index, 1)
    },

    cancelVariationEdit() {
      this.showVariationForm = false
      this.editingVariation = null
      this.editingIndex = -1
    },
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }

  }
}
</script>

<style scoped>
[type='text'], [type='number'], [type='email'], [type='url'], [type='password'], [type='search'],
[type='tel'], [type='file'], select, textarea {
  text-align: right;
  direction: rtl;
}
.bg-white {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
}

.border-gray-300 {
  border-color: rgba(209, 213, 219, 0.5);
}

input:not([type="radio"]),
select,
textarea {
  background-color: rgba(249, 250, 251, 0.8);
  border: 1px solid rgba(209, 213, 219, 0.6);
  box-shadow:
      inset 0 1px 2px rgba(0, 0, 0, 0.05),
      0 2px 4px rgba(0, 0, 0, 0.02);
  transition: all 0.3s ease;
  padding: 0.65rem 1rem;
  border-radius: 8px;
}

input:not([type="radio"]):focus,
select:focus,
textarea:focus {
  border-color: #3b82f6;
  box-shadow:
      0 0 0 3px rgba(59, 130, 246, 0.2),
      inset 0 1px 2px rgba(0, 0, 0, 0.05);
  background-color: white;
  outline: none;
}

label {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
  display: block;
}

input[type="radio"] {
  width: 1.2em;
  height: 1.2em;
  border: 2px solid #d1d5db;
  transition: all 0.2s ease;
}

input[type="radio"]:checked {
  border-color: #3b82f6;
  background-color: #3b82f6;
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e");
}

.border-dashed {
  border: 2px dashed rgba(59, 130, 246, 0.4);
  background-color: rgba(239, 246, 255, 0.5);
  transition: all 0.3s ease;
}

.border-dashed:hover {
  border-color: rgba(59, 130, 246, 0.7);
  background-color: rgba(239, 246, 255, 0.8);
}

button[type="submit"] {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  box-shadow:
      0 4px 6px -1px rgba(59, 130, 246, 0.3),
      0 2px 4px -1px rgba(59, 130, 246, 0.2);
  position: relative;
  overflow: hidden;
}

button[type="submit"]:hover {
  transform: translateY(-1px);
  box-shadow:
      0 10px 15px -3px rgba(59, 130, 246, 0.3),
      0 4px 6px -2px rgba(59, 130, 246, 0.2);
}

button[type="submit"]:active {
  transform: translateY(0);
}

button[type="submit"]::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
      to bottom right,
      rgba(255, 255, 255, 0.3),
      rgba(255, 255, 255, 0)
  );
  transform: rotate(30deg);
  transition: all 0.3s ease;
}

button[type="submit"]:hover::after {
  left: 100%;
}

.border-red-300 {
  border-color: #fca5a5;
}

.text-red-600 {
  color: #dc2626;
}

img {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

img:hover {
  transform: scale(1.02);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

h2 {
  position: relative;
  padding-left: 1.5rem;
}

h2:before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 70%;
  width: 4px;
  background: linear-gradient(to bottom, #3b82f6, #2563eb);
  border-radius: 2px;
}

.relative .text-gray-500 {
  color: #6b7280;
  font-weight: 500;
}

button[type="button"][title="تولید خودکار"] {
  background: rgba(243, 244, 246, 0.8);
  border: 1px solid rgba(209, 213, 219, 0.6);
  transition: all 0.2s ease;
}

button[type="button"][title="تولید خودکار"]:hover {
  background: rgba(229, 231, 235, 0.8);
}
.variation-card {
  transition: all 0.3s ease;
}

.variation-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.delete-btn {
  transition: all 0.2s ease;
  color: #de4444;

}
.delete-btn:hover {
  color: #ef4444;
  transform: scale(1.1);
}

@media (max-width: 768px) {
  input:not([type="radio"]),
  select,
  textarea {
    padding: 0.75rem;
  }
}
</style>